import { useState } from "react";
import { useBrandLogo } from "@/lib/brandLogo";
import { UdyogLogo } from "@/components/UdyogLogo";

/**
 * The host's contact-card icon: their uploaded brand logo, always shown as a
 * circle so it sits in the same rhythm as everyone else's animal avatar.
 * A square logo fills the circle edge to edge; a wide/landscape one is fitted
 * inside instead of being cropped in half.
 */
export function BrandAvatar({ size = 36, testid }) {
  const logo = useBrandLogo();
  const [wide, setWide] = useState(false);
  return (
    <div
      className="shrink-0 rounded-full ring-1 ring-emerald-500/40 bg-neutral-950 overflow-hidden grid place-items-center"
      style={{ width: size, height: size }}
      data-testid={testid}
    >
      {logo ? (
        <img
          src={logo}
          alt=""
          draggable={false}
          onLoad={(e) => {
            const { naturalWidth: w, naturalHeight: h } = e.currentTarget;
            if (w && h) setWide(Math.abs(w - h) / Math.max(w, h) > 0.25);
          }}
          className={`w-full h-full ${wide ? "object-contain p-1.5" : "object-cover"}`}
        />
      ) : (
        <UdyogLogo size={Math.max(10, Math.round(size * 0.42))} variant="icon" />
      )}
    </div>
  );
}
